import ServiceCRUD from '../../../../services/ServiceGasOrder';

class StockPerHourService extends ServiceCRUD {
  constructor() {
    super(`/api/verificar-estoque`);
  }
}

export default new StockPerHourService();
